export default class PackageTypes {
 
    public static SET_PACKAGE_DETAILS = 'SET_PACKAGE_DETAILS';
    public static SET_PACKAGE_LIST = 'SET_PACKAGE_LIST';
    public static SET_DOCTOR_SPECIALISTS_LIST= 'SET_DOCTOR_SPECIALISTS_LIST';
    public static SELECTED_PACKAGE = 'SELECTED_PACKAGE';
    public static SELECTED_PERSONAL_DOCTOR = 'SELECTED_PERSONAL_DOCTOR';
    public static SET_CART_ITEM_DETAILS = 'SET_CART_ITEM_DETAILS;'
}
